import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f9fafb',
      padding: '24px'
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '400px'
      }}>
        <h1 style={{
          fontSize: '120px',
          fontWeight: 'bold',
          color: '#2563eb',
          margin: 0,
          lineHeight: 1
        }}>
          404
        </h1>
        
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginTop: '16px'
        }}>
          Sayfa Bulunamadı
        </h2>
        
        <p style={{
          color: 'var(--text-secondary)',
          marginTop: '8px',
          fontSize: '16px'
        }}>
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
        
        <Link 
          to="/dashboard"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            marginTop: '24px',
            padding: '12px 24px',
            backgroundColor: '#2563eb',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '14px',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
        >
          ← Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
}
